import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ApprovalEngineDetailRBACPage = {
  pageID: '923e972133bf604f2db74da5b7b701c9',
  elementID: {
    ViewDetailPage: 'a97bfa01b0c929e6e6d4abe35fa1b899',
  },
} as const

export const useApprovalEngineDetailRBACPage = createUseRBAC(ApprovalEngineDetailRBACPage.elementID)

export type UseApprovalEngineDetailRBACPageType = ReturnType<typeof useApprovalEngineDetailRBACPage>
